import Box from 'v2/components/UI/Box';
import { ITableMainProps } from './types';
import Text from 'v2/components/UI/Text';

import InputWithIcon from 'v2/components/Inputs/InputWithIcon';
import ButtonBase from 'v2/components/UI/ButtonBase';
import ButtonCta from 'v2/components/ButtonCta';
import Icon from 'v2/components/Icon';
import { Tooltip } from '@mui/material';
import * as SC from './styles';
const TableMain: React.FC<ITableMainProps> = ({
  title,
  titleButtonCta,
  titleButtonSearch,
  isActiveDownload,
  headerOptions,
  bodyOptions,
  valueInputSearch,
  handleClickOption,
  onChangeInputSearch,
  handleClickButtonCtaHeader,
}) => {
  const renderInputSearch = () => {
    if (titleButtonSearch) {
      return (
        <InputWithIcon
          isSearch
          placeholder={titleButtonSearch}
          maxWidth={350}
          value={valueInputSearch}
          onChange={onChangeInputSearch}
        />
      );
    }
  };
  const renderDownload = () => {
    if (isActiveDownload) {
      return (
        <ButtonBase
          alignItems="center"
          justifyContent="center"
          borderRadius={100}
          width={36}
          height={36}
        >
          <Tooltip title="Baixar dados">
            <span>
              <Icon
                iconName="FileDownloadOutlined"
                htmlColor="#005F47"
                size={30}
              />
            </span>
          </Tooltip>
        </ButtonBase>
      );
    }
  };

  const renderEmptyOrContent = () => {
    if (bodyOptions.length === 0) {
      return (
        <Box
          width={'100%'}
          alignItems="center"
          justifyContent="flex-start"
          padding={20}
          borderRadius={10}
        >
          <Text fontSize={16} color="#471100" fontWeight={500}>
            Nenhum dado encontrado
          </Text>
        </Box>
      );
    }
    return (
      <Box width={'100%'} overflow="auto" marginTop={20} borderRadius={10}>
        <SC.Table>
          <SC.TableHead>
            <SC.TableRowHead>
              {headerOptions.map((option, index) => (
                <SC.TableCellHead key={index}>{option}</SC.TableCellHead>
              ))}
            </SC.TableRowHead>
          </SC.TableHead>
          <SC.TableBody>
            {bodyOptions.map((option, index) => (
              <SC.TableRow
                key={index}
                onClick={() => handleClickOption && handleClickOption(index)}
              >
                {option.map((item, cellIndex: number) => {
                  if (cellIndex === 0) {
                    return;
                  }
                  return <SC.TableCell key={cellIndex}>{item}</SC.TableCell>;
                })}
              </SC.TableRow>
            ))}
          </SC.TableBody>
        </SC.Table>
      </Box>
    );
  };
  return (
    <Box flexDirection="column" width={'100%'} gap={30}>
      <Box alignItems="center" justifyContent="space-between" width={'100%'}>
        <Text fontSize={24} fontWeight={700} color="#1B1B1B">
          {title}
        </Text>

        <ButtonCta
          iconLeft
          iconName="AddOutlined"
          title={titleButtonCta}
          handleClick={() =>
            handleClickButtonCtaHeader && handleClickButtonCtaHeader()
          }
          width={'auto'}
          sizeIcon={20}
          fontSize={14}
        />
      </Box>

      <Box
        padding={20}
        borderRadius={12}
        background="#fff"
        flexDirection="column"
        width={'100%'}
      >
        <Box
          width={'100%'}
          justifyContent="space-between"
          alignContent="center"
        >
          {renderInputSearch()}
          {renderDownload()}
        </Box>
        {renderEmptyOrContent()}
      </Box>
    </Box>
  );
};
export default TableMain;
